export enum ReportActionType {
  GET_REPORTS_TREE_REQUEST = 'GET_REPORTS_TREE_REQUEST',
  GET_REPORTS_TREE_SUCCESS = 'GET_REPORTS_TREE_SUCCESS',
  GET_REPORTS_TREE_FAIL = 'GET_REPORTS_TREE_FAIL',
  GET_REPORTS_REQUEST = 'GET_REPORTS_REQUEST',
  GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS',
  GET_REPORTS_FAIL = 'GET_REPORTS_FAIL',
  GET_REPORT_QUICK_RANGES_REQUEST = 'GET_REPORT_QUICK_RANGES_REQUEST',
  GET_REPORT_QUICK_RANGES_SUCCESS = 'GET_REPORT_QUICK_RANGES_SUCCESS',
  GET_REPORT_QUICK_RANGES_FAIL = 'GET_REPORT_QUICK_RANGES_FAIL',
  GET_ALL_REPORT_COLUMNS_REQUEST = 'GET_ALL_REPORT_COLUMNS_REQUEST',
  GET_ALL_REPORT_COLUMNS_SUCCESS = 'GET_ALL_REPORT_COLUMNS_SUCCESS',
  GET_ALL_REPORT_COLUMNS_FAIL = 'GET_ALL_REPORT_COLUMNS_FAIL',
  GET_COLLECTIONS_FOR_REPORT_REQUEST = 'GET_COLLECTIONS_FOR_REPORT_REQUEST',
  GET_COLLECTIONS_FOR_REPORT_SUCCESS = 'GET_COLLECTIONS_FOR_REPORT_SUCCESS',
  GET_COLLECTIONS_FOR_REPORT_FAIL = 'GET_COLLECTIONS_FOR_REPORT_FAIL',
  PREPARE_EXPORT_REPORT_REQUEST = 'PREPARE_EXPORT_REPORT_REQUEST',
  PREPARE_EXPORT_REPORT_SUCCESS = 'PREPARE_EXPORT_REPORT_SUCCESS',
  PREPARE_EXPORT_REPORT_FAIL = 'PREPARE_EXPORT_REPORT_FAIL',
  COPY_REPORT_FAIL = 'COPY_REPORT_FAIL',
  GET_REPORT_REQUEST = 'GET_REPORT_REQUEST',
  GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS',
  GET_REPORT_FAIL = 'GET_REPORT_FAIL',
  GET_EXECUTED_REPORT_REQUEST = 'GET_EXECUTED_REPORT_REQUEST',
  GET_EXECUTED_REPORT_SUCCESS = 'GET_EXECUTED_REPORT_SUCCESS',
  GET_EXECUTED_REPORT_FAIL = 'GET_EXECUTED_REPORT_FAIL',
  UPDATE_EXECUTED_REPORT_REQUEST = 'UPDATE_EXECUTED_REPORT_REQUEST',
  UPDATE_EXECUTED_REPORT_SUCCESS = 'UPDATE_EXECUTED_REPORT_SUCCESS',
  UPDATE_EXECUTED_REPORT_FAIL = 'UPDATE_EXECUTED_REPORT_FAIL',
  EXECUTE_REPORT_REQUEST = 'EXECUTE_REPORT_REQUEST',
  EXECUTE_REPORT_SUCCESS = 'EXECUTE_REPORT_SUCCESS',
  EXECUTE_REPORT_FAIL = 'EXECUTE_REPORT_FAIL',
  CREATE_REPORT_REQUEST = 'CREATE_REPORT_REQUEST',
  CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS',
  CREATE_REPORT_FAIL = 'CREATE_REPORT_FAIL',
  EDIT_REPORT_REQUEST = 'EDIT_REPORT_REQUEST',
  EDIT_REPORT_SUCCESS = 'EDIT_REPORT_SUCCESS',
  EDIT_REPORT_FAIL = 'EDIT_REPORT_FAIL',
  DELETE_REPORT_REQUEST = 'DELETE_REPORT_REQUEST',
  DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS',
  DELETE_REPORT_FAIL = 'DELETE_REPORT_FAIL',
  GET_COLUMNS_REQUEST = 'GET_COLUMNS_REQUEST',
  GET_COLUMNS_SUCCESS = 'GET_COLUMNS_SUCCESS',
  GET_COLUMNS_FAIL = 'GET_COLUMNS_FAIL',
  GET_COLUMN_REQUEST = 'GET_COLUMN_REQUEST',
  GET_COLUMN_SUCCESS = 'GET_COLUMN_SUCCESS',
  GET_COLUMN_FAIL = 'GET_COLUMN_FAIL',
  CREATE_COLUMN_REQUEST = 'CREATE_COLUMN_REQUEST',
  CREATE_COLUMN_SUCCESS = 'CREATE_COLUMN_SUCCESS',
  CREATE_COLUMN_FAIL = 'CREATE_COLUMN_FAIL',
  EDIT_COLUMN_REQUEST = 'EDIT_COLUMN_REQUEST',
  EDIT_COLUMN_SUCCESS = 'EDIT_COLUMN_SUCCESS',
  EDIT_COLUMN_FAIL = 'EDIT_COLUMN_FAIL',
  DELETE_COLUMN_REQUEST = 'DELETE_COLUMN_REQUEST',
  DELETE_COLUMN_SUCCESS = 'DELETE_COLUMN_SUCCESS',
  DELETE_COLUMN_FAIL = 'DELETE_COLUMN_FAIL',
  GET_REGEX_REQUEST = 'GET_REGEX_REQUEST',
  GET_REGEX_SUCCESS = 'GET_REGEX_SUCCESS',
  GET_REGEX_FAIL = 'GET_REGEX_FAIL',
  CREATE_REPORT_GROUP_REQUEST = 'CREATE_REPORT_GROUP_REQUEST',
  CREATE_REPORT_GROUP_SUCCESS = 'CREATE_REPORT_GROUP_SUCCESS',
  CREATE_REPORT_GROUP_FAIL = 'CREATE_REPORT_GROUP_FAIL',
  EDIT_REPORT_GROUP_SUCCESS = 'EDIT_REPORT_GROUP_SUCCESS',
  EDIT_REPORT_GROUP_FAIL = 'EDIT_REPORT_GROUP_FAIL',
  EDIT_REPORT_GROUP_REQUEST = 'EDIT_REPORT_GROUP_REQUEST',
  DELETE_REPORT_GROUP_REQUEST = 'DELETE_REPORT_GROUP_REQUEST',
  DELETE_REPORT_GROUP_SUCCESS = 'DELETE_REPORT_GROUP_SUCCESS',
  DELETE_REPORT_GROUP_FAIL = 'DELETE_REPORT_GROUP_FAIL',
  GET_LISTS_FOR_REPORT_REQUEST = 'GET_LISTS_FOR_REPORT_REQUEST',
  GET_LISTS_FOR_REPORT_SUCCESS = 'GET_LISTS_FOR_REPORT_SUCCESS',
  GET_LISTS_FOR_REPORT_FAIL = 'GET_LISTS_FOR_REPORT_FAIL',
  GET_REPORT_SUGGESTIONS_REQUEST = 'GET_REPORT_SUGGESTIONS_REQUEST',
  GET_REPORT_SUGGESTIONS_SUCCESS = 'GET_REPORT_SUGGESTIONS_SUCCESS',
  GET_REPORT_SUGGESTIONS_FAIL = 'GET_REPORT_SUGGESTIONS_FAIL',
  GET_MAPS_REPORTS_DEFINITION_REQUEST= 'GET_MAPS_REPORTS_DEFINITION_REQUEST',
  GET_MAPS_REPORTS_DEFINITION_SUCCESS= 'GET_MAPS_REPORTS_DEFINITION_SUCCESS',
  GET_MAPS_REPORTS_DEFINITION_DEFAULT_REQUEST= 'GET_MAPS_REPORTS_DEFINITION_DEFAULT_REQUEST',
  GET_MAPS_REPORTS_DEFINITION_DEFAULT_SUCCESS= 'GET_MAPS_REPORTS_DEFINITION_DEFAULT_SUCCESS',
  GET_MAPS_REPORTS_DEFINITION_DEFAULT_FAIL= 'GET_MAPS_REPORTS_DEFINITION_DEFAULT_FAIL',
  GET_MAPS_REPORTS_DEFINITION_FAIL= 'GET_MAPS_REPORTS_DEFINITION_FAIL',
  GET_ZONES_LIST_FOR_MAPS_REQUEST= 'GET_ZONES_LIST_FOR_MAPS_REQUEST',
  GET_ZONES_FOR_MAPS_LIST_SUCCESS= 'GET_ZONES_FOR_MAPS_LIST_SUCCESS',
  GET_ZONES_FOR_MAPS_LIST_FAIL= 'GET_ZONES_FOR_MAPS_LIST_FAIL',
  GET_MAP_REPORT_REQUEST= 'GET_MAP_REPORT_REQUEST',
  GET_MAP_REPORT_SUCCESS= 'GET_MAP_REPORT_SUCCESS',
  GET_MAP_REPORT_FAIL= 'GET_MAP_REPORT_FAIL',
  MAP_CONTROLS_STATE = 'MAP_CONTROLS_STATE',
  MAP_CONTROLS_STATE_FAIL = 'MAP_CONTROLS_STATE_FAIL',
  EDIT_MAP_REPORT_DEFINITION_REQUEST = 'EDIT_MAP_REPORT_DEFINITION_REQUEST',
  EDIT_MAP_REPORT_DEFINITION_SUCCESS = 'EDIT_MAP_REPORT_DEFINITION_SUCCESS',
  EDIT_MAP_REPORT_DEFINITION_FAIL = 'EDIT_MAP_REPORT_DEFINITION_FAIL',
  RESET_EXECUTED_REPORT = 'RESET_EXECUTED_REPORT',
}
